import { render, staticRenderFns } from "./rectangleBalloon.vue?vue&type=template&id=7bfbc138&"
import script from "./rectangleBalloon.vue?vue&type=script&lang=ts&"
export * from "./rectangleBalloon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports